import { getApi } from '../utils/api'

export function getSystemInit() {
  return getApi({ endpoint: 'idwell-api/api/v3/system/init/' })
}

export function getSystemCountries() {
  return getApi({ endpoint: 'api/system/dict/country/' })
}

export function getSystemCountryCities(countryId) {
  return getApi({ endpoint: `api/system/dict/country/${countryId}/city/` })
}

export function getSystemLanguages() {
  return getApi({ endpoint: 'api/system/dict/language/' })
}
